
// Car
export const CarOptions = {
  transmission: [
    { value: '0', label: 'Tự động' },
    { value: '1', label: 'Số sàn' },
  ],
  toyota: [
    { value: 'vios', label: 'Vios' },
    { value: 'wigo', label: 'Wigo' },
    { value: 'avanza', label: 'Avanza' },
    { value: 'innova', label: 'Innova' },
  ],
  hyundai: [
    { value: 'i10', label: 'I10' },
    { value: 'accent', label: 'Accent' },
  ],
  kia: [
    { value: 'morning', label: 'Morning' },
    { value: 'soluto', label: 'Soluto' },
  ],
};

// Gender
export const GenderOptions = [
  { value: 0, label: 'Nữ' },
  { value: 1, label: 'Nam' },
  { value: 2, label: 'Khác' }
];